import EdiIconFinanway from "assets/logos_finanway/iconos_archivos/icon_edi.svg"
import XlxsIconFinanway from "assets/logos_finanway/iconos_archivos/icon_excel.svg"
import PdfIconFinanway from "assets/logos_finanway/iconos_archivos/icon_pdf.svg"
import XmlIconFinanway from "assets/logos_finanway/iconos_archivos/icon_xml.svg"

import UsuarioVerificadoFinanway from "assets/logos_finanway/general/usuario_verificado.svg"

export const STATIC_ASSETS_URL = "https://static.finanedi.es/assets"

export const DOCUMENT_PREFIX = "ERP"

export const APP_STYLE_SETTINGS_FINANWAY = {
  title: "FinanEDI ERP",
  stylesheet: "./styles/finanway-styles/main.scss",
  mainLogo: `${STATIC_ASSETS_URL}/logo/logo-light-erp.svg`,
  sidebarLogoSmall: `${STATIC_ASSETS_URL}/logo/isotipo-light-erp.svg`,
  sidebarLogoBig: `${STATIC_ASSETS_URL}/logo/logo-light-erp.svg`,
  crm: `${STATIC_ASSETS_URL}/logo/isotipo-hor-dark-crm.svg`,
  erp: `${STATIC_ASSETS_URL}/logo/isotipo-hor-dark-erp.svg`,
  ops: `${STATIC_ASSETS_URL}/logo/isotipo-hor-dark-ops.svg`,

  primary: "#1a2543",
  secondary: "#00d8ac",
  bicolorIcon: `${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/Bicolor.svg`,
  crmIsotipo: `${STATIC_ASSETS_URL}/logo/logo-dark-crm.svg`,
  opsIsotipo: `${STATIC_ASSETS_URL}/logo/logo-dark-ops.svg`,
  favicon: `${STATIC_ASSETS_URL}/logo/isotipo-dark.svg`,

  // ICONOS IMPORTACION
  pdf: PdfIconFinanway,
  xml: XmlIconFinanway,
  xlxs: XlxsIconFinanway,
  edi: EdiIconFinanway,

  emptyAprovement: UsuarioVerificadoFinanway,
}

export const setInitialTitleFavicon = (settings: $TSMigrationFixMe) => {
  const favicon = document.getElementById("favicon")
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  favicon.href = settings.favicon
  document.title = settings.title
}
